<nb-auth-block>
    <h2 class="title">Cambia password</h2>
    <small class="form-text sub-title">Inserisci la nuova password</small>
    <form
        (ngSubmit)="resetPassword()"
        #resetPassForm="ngForm"
    >
        <div class="form-group">
            <label
                for="input-password"
                class="sr-only"
            >Nuova password</label>
            <input
                name="password"
                [(ngModel)]="user_password"
                type="password"
                id="input-password"
                class="m-2 form-control form-control-lg first"
                placeholder="Nuova Password"
                #password="ngModel"
                [class.form-control-danger]="password.invalid && password.dirty"
                [required]="true"
                [minlength]="8"
                [maxlength]="50"
                [pattern]="password_pattern"
                autofocus
            >
            <small
                class="form-text error"
                *ngIf="password.invalid && password.dirty"
            >
                La password deve contenere da almeno 8 caratteri, di cui almeno uno maiuscolo, uno minuscolo e una cifra </small>
            <label
                for="input-re-password"
                class="sr-only"
            >Ripeti password</label>
            <input
                name="rePass"
                [(ngModel)]="user_confirmPassword"
                type="password"
                id="input-re-password"
                class="m-2 form-control form-control-lg last"
                placeholder="Conferma nuova Password"
                #rePass="ngModel"
                [class.form-control-danger]="(rePass.invalid || password.value != rePass.value) && rePass.touched"
                [required]="true"
            >
            <small
                class="form-text error"
                *ngIf="rePass.invalid && rePass.touched"
            > Richiesta conferma </small>
            <small
                class="form-text error"
                *ngIf="rePass.touched && !confirmedPassword"
            > Le due password non corrispondono </small>
        </div>
        <button
            [nbSpinner]="loading"
            [disabled]="loading || resetted || password.invalid || !confirmedPassword"
            nbButton
            class="btn-block"
        > Cambia password </button>
    </form>

    <!-- 
  <pre *ngIf="resetPassForm">
    {{resetPassForm.form | json}}
  </pre>

  <pre *ngIf="password">
    {{password.errors | json}}
    {{password.invalid | json}}
  </pre>

  <pre *ngIf="rePass">
    {{rePass.errors | json}}
    {{rePass.invalid | json}}
  </pre> -->

</nb-auth-block>
